import {ReactElement} from 'react';
import {Alert, AlertColor, Snackbar, SnackbarOrigin} from '@mui/material';

type Props = {
  open: boolean;
  message: string;
  severity: AlertColor;
  onClose: () => void;
  autoHideDuration?: number;
  anchorOrigin?: SnackbarOrigin;
};

export default function Toast({
  open,
  message,
  severity,
  onClose,
  autoHideDuration = 6000,
  anchorOrigin = {vertical: 'bottom', horizontal: 'left'}
}: Props): ReactElement {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert severity={severity} variant="filled" onClose={onClose} sx={{width: '100%'}}>
        {message}
      </Alert>
    </Snackbar>
  );
}
